import { css } from "@emotion/react";
import cx from "classnames";

import { VARS } from "styles-js";


const errorStyles = css({
  fontSize: "12px",
  textAlign: "left",
  lineHeight: 1.6,
  color: VARS.form.errorColor,
  transition: "opacity 160ms ease, margin-top 160ms ease"
});

const hiddenStyles = css({
  opacity: 0,
  marginTop: "0px"
});

const visibleStyles = css({
  opacity: 1,
  marginTop: "5px"
});

interface FormValidationProps {
  className?: string;
  isVisible: boolean;
  errorMessage: string;
}

export default function FormValidation({
  className,
  isVisible,
  errorMessage
}: FormValidationProps) {

  return (
    <div
      css={[
        errorStyles,
        isVisible ? visibleStyles : hiddenStyles
      ]}
      className={cx("form-messages", className)}>
      {isVisible && (
        <>{errorMessage}</>
      )}
    </div>
  );
}
